import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import style from "./Modal.module.css";
import moment from "moment";
import {
	Row,
	Col,
	Button,
	Card,
	Table,
	Form,
	Container,
	Modal,
	Tabs,
	Tab,
} from "react-bootstrap";
import { FaTachometerAlt, FaCalendarAlt, FaUsers, FaUser, FaArrowRight, FaSpinner, FaLifeRing, FaUndoAlt, FaPen } from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan, FaS} from "react-icons/fa6";
import { apiCall } from "../api/apiUtil";

function BusinessInterestEmpDashboard() {
	const [globalCode, setGlobalCode] = useState(null);
	const [finYear, setFinYear] = useState("");
	const [businessInterestList, setBusinessInterestList] = useState([]);
	const [businessInterestId, setBusinessInterestId] = useState(null);
	const [showEmployeeActionModal, setShowEmployeeActionModal] = useState(false);
	const [isModalFormSubmissionStatus, setIsModalFormSubmissionStatus] = useState(false);
	const [employeeAckStatus, setEmployeeAckStatus] = useState(null);
	const [employeeResponse, setEmployeeResponse] = useState("");

	const getFinancialYear = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0 = Jan
        let fy = "";
        
        if (month >= 3) { // April or later
            fy = `${year}-${(year + 1).toString().slice(-2)}`;
        } else {
            fy = `${year - 1}-${year.toString().slice(-2)}`;
        }
        setFinYear(fy);        
        return fy;
    };

	const [selectedMonth, setSelectedMonth] = useState(() => {
		const today = moment();
		// // Get Current week's Monday
		// const currentMonday = moment().startOf('week').add(1, 'day');
		// // Get Current week's Sunday
		// const currentSunday = moment(currentMonday).add(6, 'days'); // this Monday + 6 = Current Sunday
		// // Build this month's 24th date
		// const thisMonth24th = moment().date(24);
		// const is24thInRange = thisMonth24th.isSameOrAfter(currentMonday, 'day') && thisMonth24th.isSameOrBefore(currentSunday, 'day');
		
		getFinancialYear(today.toDate());

		return today.toDate();
	});

	const navigate = useNavigate();

	useEffect(() => {
		let globalCode = sessionStorage.getItem("globalCode");
		setGlobalCode(globalCode);
		if(globalCode) {
			getAcknowledgements(globalCode);
		} else {
			navigate("/");
		}
	}, [navigate]);

	const getAcknowledgements = (globalCode) => {
		apiCall(`/VendorCompliance/GetVendorRelations/employee-pov/${globalCode}/${finYear}` , {
			method: "GET"
		})
		.then((response) => {
			let data = response;
			//console.log("Backend Response:", data);
			setBusinessInterestList(data ?? []);
		})
		.catch((err) => {
			alert(err);
			console.error("Error:", err);
		});
	};

	const handleEmployeeAction = (id) => {
		setBusinessInterestId(id);
		setShowEmployeeActionModal(true);
	}

	const updateEmployeeAcknowledgementStatus = async (event) => {
		event.preventDefault();

		let employeeAckObj = {
			id: businessInterestId,
			employeeResponseStatus: employeeResponse,
			employeeAck: employeeAckStatus
		};
		apiCall(`/VendorCompliance/UpdateVendorEmployeeRelation/${businessInterestId}`, {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(employeeAckObj),
		})
		.then((data) => {
			if (data.success) {
				alert(data.message);
				setShowEmployeeActionModal(false);
				setBusinessInterestId(null);
				getAcknowledgements(globalCode);
			} else {				
				alert(data.message);
			}
		})
        .catch((err) => {
            alert(err);
            console.error("Error:", err);
        });

	}

	return (
		<div className="d-flex flex-column min-vh-100">
			<Container className="flex-grow-1 mt-3 mb-3">
				<div className="row">
					<div className="col bg-light mb-2 d-flex justify-content-between align-items-center">
						<h5 className="mt-1">
							<FaTachometerAlt className="me-2" /> Vendor Business Interest Status
						</h5>
					</div>
					<div className="gap-2 ms-auto" style={{width: "250px"}}>
						<label className="align-items-center">Financial Year: {finYear}</label>
						{/* Month Picker with Calendar Icon inside Input */}
						<div className="position-relative">
							<DatePicker selected={selectedMonth} onChange={(date) => setSelectedMonth(date)} dateFormat="MMMM yyyy" showMonthYearPicker className="form-control pe-5" />
							{/* Calendar Icon Inside Input */}
							<FaCalendarAlt className="position-absolute text-muted"
								style={{
									top: 20,
									right: "10px",
									transform: "translateY(-50%)",
									fontSize: "1.2rem",
									cursor: "pointer",
								}}
								onClick={() =>
									document
										.querySelector(".react-datepicker__input-container input")
										.focus()
								} // Trigger DatePicker on click
							/>
							{/* <span style={{fontSize: "13px", color: "red"}}>24th of {moment(selectedMonth).subtract(1, "M").format("MMMM YYYY")} to 23rd of {moment(selectedMonth).format("MMMM YYYY")}</span> */}
						</div>
						{/* <Button variant="success" size="sm">
							Completed
						</Button> */}
					</div>
				</div>
				<br />
				<div className="d-flex justify-content-end">
					<a href="/user-dashboard" className="me-3">
						<Button variant="warning" size="sm">
							<FaUser className="me-2" /> Self Review
						</Button>
					</a>
				</div>
				<Card>
					<Card.Body>
						<div className="table-responsive">
							<Table striped bordered hover className="mt-3">
								<thead>
                                    <tr>
                                        <th>Org Unit</th>
                                        <th>Vendor Code</th>
                                        <th>Vendor Name</th>
                                        <th>Unit</th>
                                        <th>Category <br /> Month</th>
                                        <th>Reconcile Status</th>
                                        <th>Acknowledgement Status</th>
										<th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
									{Array.isArray(businessInterestList) && businessInterestList.map((interest, index) => (
										<tr>
											<td>{interest?.orgUnit}</td>
											<td>{interest?.vendorCode}</td>
											<td>{interest?.vendorName}</td>
											<td>{interest?.unit}</td>
											<td>{interest?.category}<br />{interest?.month} - {interest?.year}</td>
											<td className="text-center">
												{(interest?.reconcileStatus == null) && (<Button variant="warning" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
												{(interest?.reconcileStatus == true) && (<Button variant="success" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
												{(interest?.reconcileStatus == false) && (<Button variant="danger" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
											</td>
											<td className="text-center">
												{(interest?.employeeAck == null) && (<Button variant="warning" title="Pending For Acknowledge" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
												{(interest?.employeeAck == true) && (<Button variant="success" title="Aligned" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
												{(interest?.employeeAck == false) && (<Button variant="danger" title="Not Aligned" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
											</td>
											<td>
												{(interest?.employeeAck == null) && (
													<Button size="sm" variant="warning" onClick={() => handleEmployeeAction(interest?.id)} style={{width: 120}}>
														<FaPen style={{ fontSize: "10px", marginRight: "4px" }} /> Acknowledge
													</Button>
												)}
												
											</td>
										</tr>
									))}
                                    {(Array.isArray(businessInterestList) && businessInterestList.length === 0) && 
                                        (
                                            <tr>
                                                <td colSpan="8" className="text-center text-muted">
                                                No records found
                                                </td>
                                            </tr>
                                        )
                                    }
								</tbody>
							</Table>
						</div>
					</Card.Body>
				</Card>
				<Modal show={showEmployeeActionModal} onHide={() => setShowEmployeeActionModal(false)} size="">
					<Modal.Header closeButton>
						<Modal.Title>RO Action</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form onSubmit={updateEmployeeAcknowledgementStatus}>
							<Form.Group>
								<div className="form-group">
									<label style={{color: "#000"}} htmlFor="Status">Status:</label>
									<Form.Select
										size="sm"
										//value={selectedRoData[id]}
										onChange={(e) =>
											setEmployeeAckStatus(e.target.value == "yes" ? true : false)
										}
										className="me-2"
										required
									>
										<option value="">Status</option>
										<option value="yes">Yes, Aligned</option>
										<option value="no">No, Not Aligned</option>
									</Form.Select>
								</div>
								<div className="form-group text-white">
									<label style={{color: "#000"}} htmlFor="email">Employee Response:</label>
									<input type="text" id="RoInput" value={employeeResponse} onChange={(e) => setEmployeeResponse(e.target.value)} placeholder="Enter Employee Comment" required autoComplete="off" />
								</div>
								<button type="submit" className="btn btn-sm btn-success float-end" disabled={isModalFormSubmissionStatus}>
									{(isModalFormSubmissionStatus) ? "Processing": "Submit"}
								</button>
							</Form.Group>
						</form>
					</Modal.Body>
				</Modal>
			</Container>
		</div>
	);
	
}

export default BusinessInterestEmpDashboard;